import { Box, Grid, TextField, Typography, Fab, Tooltip, useTheme } from '@mui/material'
import React, { useContext } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ButtonBasic } from '../../components'
import AuthService from '../../services/auth.service'
import { ColorModeContext } from '../../themes/themes'
import LightModeIcon from '@mui/icons-material/LightMode'
import DarkModeIcon from '@mui/icons-material/DarkMode'

const RecoverPasswordScreen = () => {
    const [textEmail, setTextEmail] = useState('');
    const [textEmailErr, setTextEmailErr] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const theme = useTheme();
    const colorMode = useContext(ColorModeContext);
    const isDarkMode = theme.palette.mode === 'dark';

    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };
    useEffect(() => {
        if(validateEmail(textEmail)){
            setTextEmailErr(false)
        }else{
            setTextEmailErr(true)
        }
    }, [textEmail])

    const onSubmit = async() =>{
        if(validateEmail(textEmail)){
            setIsLoading(true)
            await AuthService.recoverPassword(textEmail).then(()=>{
                navigate(`/recover/password/ok/${textEmail}`)
            }).catch(()=>{
                setIsLoading(false)
            })
        }
    }
    return (
        <Box 
            sx={{
                minHeight: '100vh', 
                width: '100%', 
                background: isDarkMode 
                    ? 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)'
                    : '#fff',
                padding: { xs: 3, md: 6, lg: 8 },
                paddingTop: { xs: 4, md: 5, lg: 6 },
                transition: 'background 0.3s ease-in-out'
            }}
        >
            {/* FAB para cambiar tema */}
            <Tooltip title={isDarkMode ? "Cambiar a modo claro" : "Cambiar a modo oscuro"} placement="left">
                <Fab
                    color="primary"
                    aria-label="toggle theme"
                    onClick={colorMode.toggleColorMode}
                    sx={{
                        position: 'fixed',
                        bottom: 24,
                        right: 24,
                        zIndex: 1000,
                        background: isDarkMode 
                            ? 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)'
                            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: isDarkMode ? '#333' : '#fff',
                        boxShadow: isDarkMode 
                            ? '0 4px 20px rgba(252, 182, 159, 0.5)'
                            : '0 4px 20px rgba(102, 126, 234, 0.5)',
                        transition: 'all 0.3s ease-in-out',
                        '&:hover': {
                            transform: 'scale(1.1) rotate(15deg)',
                            background: isDarkMode 
                                ? 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)'
                                : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            boxShadow: isDarkMode 
                                ? '0 6px 25px rgba(252, 182, 159, 0.7)'
                                : '0 6px 25px rgba(102, 126, 234, 0.7)',
                        }
                    }}
                >
                    {isDarkMode ? <LightModeIcon /> : <DarkModeIcon />}
                </Fab>
            </Tooltip>

            <img 
                src={isDarkMode ? '/img/Zeta-white.png' : '/img/Zeta-black.png'} 
                alt="Zeta Logo"
                style={{
                    height: 80,
                    width: 170,
                    filter: isDarkMode 
                        ? 'drop-shadow(0 2px 10px rgba(255, 255, 255, 0.1))'
                        : 'none'
                }} 
            />
            <Grid container sx={{ mt: 2 }}>
                <Grid item xs={12} md={8} lg={6} xl={5} sx={{display: 'flex',justifyContent: 'center', alignItems: 'center'}}>
                    <img 
                        src='/img/recoverPassword.png' 
                        alt="Recover Password"
                        style={{
                            width: 350, 
                            height: 350,
                            filter: isDarkMode ? 'brightness(0.9)' : 'none'
                        }} 
                    />
                </Grid>
                <Grid item flex={1} xs={12} md={4} lg={6} xl={7} sx={{display: 'flex',justifyContent: 'center', alignItems: 'center',flexDirection: 'column'}}>
                    <Typography 
                        sx={{
                            color: isDarkMode ? '#fff' : '#000',
                            fontWeight: 'bold',
                            textAlign: { xs: 'center', md: 'left' }
                        }} 
                        variant='h1'
                    >
                        ¿Olvidaste tu contraseña?
                    </Typography>
                    <Typography 
                        sx={{
                            color: isDarkMode ? 'rgba(255, 255, 255, 0.8)' : '#000',
                            marginTop: 2,
                            textAlign: { xs: 'center', md: 'left' }
                        }} 
                        variant='h5'
                    >
                        Ingresa el correo electrónico con el que te dieron de alta inicialmente.
                    </Typography>
                    <Typography 
                        sx={{
                            color: isDarkMode ? 'rgba(255, 255, 255, 0.8)' : '#000',
                            textAlign: { xs: 'center', md: 'left' }
                        }} 
                        variant='h5'
                    >
                        Te enviaremos un link para recuperar tu clave.
                    </Typography>
                    <TextField
                        variant='standard'
                        type='email'
                        label='Email'
                        value={textEmail}
                        onChange={(e)=>setTextEmail(e.target.value)}
                        InputLabelProps={{
                            style:{
                                color: isDarkMode ? 'rgba(255, 255, 255, 0.7)' : '#000', 
                                fontSize: 17
                            }
                        }}
                        InputProps={{ 
                            style:{ 
                                fontWeight: 'bold',
                                fontSize: 15,
                                color: isDarkMode ? '#fff' : '#000' 
                            } 
                        }}
                        error={textEmailErr}
                        helperText={textEmailErr && 'Ingrese un correo valido'}
                        sx={{
                            width: { xs: '100%', sm: 450 },
                            marginTop: 5,
                            '& .MuiInputBase-input': {
                                color: isDarkMode ? '#fff' : '#000',
                                '&:-webkit-autofill': {
                                    WebkitBoxShadow: isDarkMode 
                                        ? '0 0 0 100px #1F2A40 inset !important'
                                        : '0 0 0 100px #fff inset !important',
                                    WebkitTextFillColor: isDarkMode ? '#fff !important' : '#000 !important',
                                }
                            },
                            "& .MuiInput-underline:after": {
                                borderBottomColor: isDarkMode ? "#64B5F6" : "#000"
                            },
                            "& .MuiInput-underline:before": {
                                borderBottomColor: isDarkMode ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.42)"
                            },
                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                borderBottomColor: isDarkMode ? "#64B5F6" : "#000"
                            },
                            '& .MuiFormHelperText-root': {
                                color: isDarkMode ? '#f48fb1' : '#d32f2f'
                            }
                        }}
                    />
                    <ButtonBasic
                        textButton='Enviar link a este mail'
                        sx={{
                            width: { xs: '100%', sm: 450 },
                            marginTop: 4,
                            height: 50,
                            borderRadius: 20,
                            fontSize: 15,
                        }}
                        variant='wk'
                        color='nextStep'
                        isDisabled={textEmailErr}
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                    />
                    <Typography
                        sx={{
                            color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'gray',
                            marginTop: 2,
                            cursor: 'pointer',
                            transition: 'color 0.2s ease',
                            '&:hover': {
                                color: isDarkMode ? '#64B5F6' : '#0364FF'
                            }
                        }}
                        onClick={()=>navigate('/login')}
                    >
                        Volver al inicio de sesión
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default RecoverPasswordScreen